import {t} from "@lingui/core/macro";

import type {Result} from "@khanacademy/wonder-blocks-data";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body, HeadingMedium} from "@khanacademy/wonder-blocks-typography";
import {ErrorMessageWrapper} from "@khan/component-error-message";
import {ReportError} from "@khan/component-screens/error-loading";
import {ShimmerRectangle} from "@khan/component-shimmer";

import type {guideTranscriptsType} from "./__graphql-types__/guideTranscripts.ts";

interface Props {
    /**
     * The query result containing status and data
     */
    result: Result<guideTranscriptsType["response"]>;
}

/**
 * Renders the loading and error content for the guide transcripts query.
 * Returns null once we're ready to render the loaded content.
 */
const GuideTranscriptsLoadingOrError = ({result}: Props): React.ReactNode => {
    if (result.status === "loading" || result.status === "no-data") {
        return <ShimmerRectangle animated={true} height="33vh" width="100%" />;
    }
    if (result.status !== "success") {
        return (
            <ErrorMessageWrapper>
                <HeadingMedium style={{textAlign: "center"}}>
                    {t`Oops. Something went wrong. Please try again.`}
                </HeadingMedium>
                <Body
                    style={{
                        textAlign: "center",
                        marginBlockStart: spacing.xLarge_32,
                    }}
                >
                    <ReportError />
                </Body>
            </ErrorMessageWrapper>
        );
    }
    return null;
};

export {GuideTranscriptsLoadingOrError as GuideTranscriptsLoadingError};
